import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { AppPasswordInput, BrandLogo, PrimaryButton } from '../../../components/ui';

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const notice = location.state?.notice;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email.trim() || !password) {
      setError('Email and password are required');
      return;
    }
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate('/admin/hub', { replace: true });
    } catch (err) {
      setError(err?.message || 'Sign in failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <VStack spacing={6} align="stretch">
        <Box textAlign="center">
          <Box display="inline-block" lineHeight={0}>
            <BrandLogo variant="full" h={{ base: '48px', sm: '56px' }} maxW="260px" />
          </Box>
          <Heading
            as="h1"
            fontSize={{ base: '22px', sm: '24px' }}
            fontWeight="700"
            color="text.primary"
            letterSpacing="-0.02em"
            mt={5}
          >
            Admin sign in
          </Heading>
          <Text color="text.secondary" mt={2} fontSize="14px" lineHeight="1.5">
            Manage villagers, vendors, and equipment matching.
          </Text>
        </Box>

        <VStack spacing={4} align="stretch">
          <FormControl isInvalid={Boolean(error) && !email.trim()}>
            <FormLabel fontSize="13px" fontWeight="600" mb={1.5}>
              Email
            </FormLabel>
            <Input
              type="email"
              placeholder="admin@utkarsh.com"
              h="52px"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </FormControl>
          <AppPasswordInput
            label="Password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            isInvalid={Boolean(error) && !password}
          />
          <Link
            as={RouterLink}
            to="/auth/forgot-password"
            state={{ email }}
            alignSelf="flex-end"
            fontSize="13px"
            fontWeight="600"
            color="text.secondary"
            _hover={{ color: 'text.primary', textDecoration: 'underline' }}
          >
            Forgot password
          </Link>
          {notice ? (
            <Text color="green.600" fontSize="13px" fontWeight="500">
              {notice}
            </Text>
          ) : null}
          {error ? (
            <Text color="status.error" fontSize="13px" fontWeight="500">
              {error}
            </Text>
          ) : null}
        </VStack>

        <PrimaryButton type="submit" w="100%" isLoading={submitting} size="md">
          Sign in
        </PrimaryButton>
      </VStack>
    </Box>
  );
}
